import { userConstants } from "../../../constants/userConstant";
import { LocalStorageService } from "../../../services";

let data = LocalStorageService.getObject("client");

const initialState = {
  loggedIn: data && data.loggedIn,
  userType: data && data.userType,
  client: data,
  campaignDates: data && data.campaignDates,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loading: true,
        name: action.name,
      };
    case userConstants.LOGIN_SUCCESS:
      LocalStorageService.set("talent-user", "true");
      let data = action.payload.client;
      data.loggedIn = true;
      data.campaignDates = action.payload.campaignDates;
      LocalStorageService.setObject("client", action.payload.client);
      return {
        loggedIn: true,
        campaigns: action.payload.campaigns,
        client: action.payload.client,
        userType: action.payload.client.userType,
        planType: action.payload.planType,
        campaignDates: action.payload.campaignDates,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        message: action.error,
        loggingIn: false,
      };
    case userConstants.LOGOUT:
      sessionStorage.clear();
      return {
        loggedIn: false,
        loggingIn: true,
        state: {},
      };
    default:
      return state;
  }
}
